import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IUnknownDeclaration } from '../interfaces';
import { UnknownDeclarationMapper } from '../mappers';

export type IGetUnknownDeclarationByIdRepoResponse = IRepoResponse<200, IUnknownDeclaration> | IRepoResponse<400 | 500, string>;

export type IGetUnknownDeclarationByIdRepo = IRepo<[number | string], IGetUnknownDeclarationByIdRepoResponse>;

export const GetUnknownDeclarationByIdRepoType = Symbol.for('GetUnknownDeclarationByIdRepo');

@bind(GetUnknownDeclarationByIdRepoType)
export class GetUnknownDeclarationByIdRepo implements IGetUnknownDeclarationByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/conflicted_declaration/info', { conflicted_declaration_id: id }) });

      if (result.status === 200) {
        const data: IUnknownDeclaration = UnknownDeclarationMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
